<template>
    <div id="cardRateConfigurationView" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="itemcategoriesHeader">View Rate Cofiguration</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content component-category-crud list-view">
                      <section class="internal-container">
                        <div id="tabs" class="containerTab mt-3">
                          <div class="tabs">
                            <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Rate Configuration Details</a>
                            <a v-on:click="activityLogs()" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Activity Log</a>
                          </div>
                          <div class="content">
                        <section v-show="activetab === 1" class="tabcontent">
                            <div class="form-row section-divider">
                                <div class="col-md-6">
                                    <div class="row form-group">
                                        <label class="col">Contract Type:</label>
                                        <span class="col"> {{ contract_type }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Customer:</label>
                                        <span class="col"> {{ customer }} </span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row form-group">
                                        <label class="col">Scope:</label>
                                        <span class="col"> {{ scope }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Effective Date:</label>
                                        <span class="col"> {{ effective_date }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Expiry Date:</label>
                                        <span class="col"> {{ expiry_date }} </span>
                                    </div>
                                </div>
                            </div>

                            <div class="btn-groups badge-buttons text-left mb-3">
                            <div class="">
                                <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                                    <button type="button" id="getFixedConfig" v-on:click="fetchRateConfig(this,'fixed')" :class="'btn btn-secondary '+ fixed"> Fixed </button>
                                    <button type="button" id="getDistConfig" v-on:click="fetchRateConfig(this,'dist')" :class="'btn btn-secondary '+ dist"> DIST </button>
                                    <button type="button" id="getReeferConfig" v-on:click="fetchRateConfig(this,'eltstb')" :class="'btn btn-secondary '+ eltstb"> ELTSTB / Electric StandBy</button>
                                    <button type="button" id="geteltsbconfig" v-on:click="fetchRateConfig(this,'enhour')" :class="'btn btn-secondary '+ enhour"> ENHOUR / Engine Hours </button>
                                    <button type="button" id="geteltsbconfig" v-on:click="fetchRateConfig(this,'rfhour')" :class="'btn btn-secondary '+ reefer"> RFHOUR / Reefer Hours </button>
                                </div>
                            </div>
                        </div>

                            <div v-if="fixed == 'active'" class="purchase-order-create-main form-group table-responsive-sm">
                                <table aria-describedby="table" class="table table-sm table-bordered font-1" >
                                    <thead>

                                        <tr class="table-primary">

                                            <th scope="col" style="width:120px;">Equipment Type</th>
                                            <th scope="col">Section</th>
                                            <th scope="col" style="border-left:2px solid white;">Base Rate</th>
                                            <th scope="col" class="text-right">%Base</th>
                                            <th scope="col" class="text-right">Day Rate</th>
                                            <th scope="col" v-if="base == 'true'" style="border-left:2px solid white;">Base Rate</th>
                                            <th scope="col" class="text-right">%Base</th>
                                            <th scope="col" class="text-right">Week Rate</th>
                                            <th scope="col" style="border-left:2px solid white;">Base Rate</th>
                                            <th scope="col" class="text-right">%Base</th>
                                            <th scope="col" class="text-right">Month Rate</th>
                                        </tr>
                                    </thead>
                                    <tbody id="myTable" v-if="rows && rows.length > 0">
                                        <tr v-for="(row, index) in rows" :key="index">
                                            <td>
                                                {{row.truck_type}}
                                            </td>
                                            <td>
                                                {{row.section}}
                                            </td>
                                            <td class="text-right">
                                                {{row.day_base_rate}}
                                                <!-- <input type="text" v-model="row.day_base_rate" :disabled="true" id="day_base_rate" name="day_base_rate" placeholder="Day Base Rate" class="form-control text-right" @keypress="isNumber($event)"> -->
                                            </td>
                                            <td class="text-right">
                                                {{row.day_discount}}
                                                <!-- <input type="text" v-model="row.day_discount" id="day_discount" name="day_discount" placeholder="Discount" @input="calculateDiscount($event,index,'day','dis')" class="form-control text-right" @keypress="isNumber($event)"> -->
                                            </td>
                                            <td class="text-right">
                                                {{row.day_rate}}
                                                <!-- <input type="text" placeholder="Rate" v-model="row.day_rate" name="day_rate" @keypress="isNumber($event)" @input="calculateDiscount($event,index,'day','rate')" id="quantity" class="form-control text-right"> -->

                                            </td>
                                            <td class="text-right">
                                                {{row.week_base_rate}}
                                                <!-- <input type="text" v-model="row.week_base_rate" :disabled="true" id="week_base_rate" name="week_base_rate" placeholder="Base Rate" @input="calculateDiscount($event,index,'week','dis')" class="form-control text-right" @keypress="isNumber($event)"> -->
                                            </td>
                                            <td v-if="displayDis" class="text-right">
                                                {{row.week_discount}}
                                                <!-- <input type="text" v-model="row.week_discount" id="week_discount" name="week_discount" placeholder="Discount" class="form-control text-right" @input="calculateDiscount($event,index,'week','dis')" @keypress="isNumber($event)"> -->
                                            </td>
                                            <td class="text-right">
                                                {{row.week_rate}}
                                                <!-- <input type="text" placeholder="Rate" v-model="row.week_rate" name="week_rate" @keypress="isNumber($event)" id="quantity" @input="calculateDiscount($event,index,'week','rate')" class="form-control text-right"> -->
                                            </td>
                                            <td class="text-right">
                                                {{row.month_base_rate}}
                                                <!-- <input type="text" v-model="row.month_base_rate" :disabled="true" id="month_base_rate" name="month_base_rate" placeholder="Base Rate" @input="calculateDiscount($event,index,'month','dis')" class="form-control text-right" @keypress="isNumber($event)"> -->
                                            </td>
                                            <td v-if="displayDis" class="text-right">
                                               {{row.month_discount}}
                                                <!-- <input type="text" v-model="row.month_discount" id="month_discount" name="month_discount" placeholder="Discount" @input="calculateDiscount($event,index,'month','dis')" class="form-control text-right" @keypress="isNumber($event)"> -->
                                            </td>
                                            <td class="text-right">
                                                {{row.month_rate}}
                                                <!-- <input type="text" placeholder="Rate" v-model="row.month_rate" name="month_rate" @input="calculateDiscount($event,index,'month','rate')" @keypress="isNumber($event)" id="quantity" class="form-control text-right"> -->
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody id="myTable" v-else>
                                        No Record Found
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="purchase-order-create-main form-group table-responsive-sm">
                                <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                    <thead>
                                        <tr class="table-primary">
                                            <th scope="col" style="width:120px;"></th>
                                            <th scope="col">&nbsp;</th>
                                            <th scope="col" style="border-left:2px solid white;">&nbsp;</th>
                                            <th scope="col" class="text-right" v-if="dist == 'active'">Mile</th>
                                            <th scope="col" class="text-right" v-else>Hour</th>
                                            <th scope="col" v-if="displayDis && base == 'true'">&nbsp;</th>
                                        </tr>
                                        <tr class="table-primary">

                                            <th scope="col" style="width:120px;">Equipment Type</th>
                                            <th scope="col">Section</th>
                                            <th scope="col" style="border-left:2px solid white;">Base Rate</th>
                                            <th scope="col" class="text-right">%Base</th>
                                            <th scope="col"  class="text-right">Rate</th>
                                        </tr>
                                    </thead>
                                    <tbody id="myTable" v-if="rows && rows.length > 0">
                                        <tr v-for="(row, index) in rows" :key="index">

                                            <td>
                                                {{row.truck_type}}
                                            </td>
                                            <td>
                                                {{row.section}}
                                            </td>
                                            <td class="text-right">
                                                {{row.base_rate}}
                                                <!-- <input type="text" v-model="row.base_rate" :disabled="displayDis" id="base_rate" name="base_rate" placeholder="Base Rate" @input="calculateDiscount($event,index,'variable','dis')" class="form-control text-right" @keypress="isNumber($event)"> -->
                                            </td>
                                            <td class="text-right">
                                                {{row.discount}}
                                                <!-- <input type="text" v-model="row.discount" id="discount" name="discount" placeholder="Discount" class="form-control text-right" @input="calculateDiscount($event,index,'variable','dis')" @keypress="isNumber($event)"> -->
                                            </td>
                                            <td class="text-right">
                                                {{row.rate}}
                                                <!-- <input type="text" placeholder="Rate" v-model="row.rate" name="rate" @keypress="isNumber($event)" @input="calculateDiscount($event,index,'variable','rate')" id="rate" class="form-control text-right"> -->
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody id="myTable" v-else>
                                        No Record Found
                                    </tbody>
                                </table>
                            </div>
                        </section>
                        <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs" >
                            <rate-activity-log-list :activityLogVal="activityLogsTabValue"></rate-activity-log-list>
                        </div>
                        </div>
                        </div>
                      </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

import ActivityLogListView from '@/components/ActivityLogList.vue';
Vue.component("rate-activity-log-list", ActivityLogListView);
export default {
  name: "cardRateConfigurationView",
  
  metaInfo() {
      return {title: "Card Rate Configuration View | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins, contractMixins],
  data: () => ({
    vehicle_type_id: null,
    vehicleTypeArr:[],
    permissions: [],
    cantAccessPage: "",
    contract_type: "",
    scope: "",
    effective_date: "",
    loading:false,
    expiry_date: "",
    customer: "",
    rows:[],
    fixed:'',
    dist:'',
    eltstb:'',
    enhour:'',
    reefer:'',
    displayDis:true,
    idArr:[],
    base:'true',
    disCheck:false,
    activeFlag:'fixed',
    activetab: 1,
    activityLogsTabValue: "dontLoadList",
    activityLoaded:false,
  }),
  created: function() {

  },
  watch:{
      //check permission change
      permissions: function (permissions) {

          var self = this;
          if (permissions.length > 0) {
              for (var i = 0; i < permissions.length; i++) {
                  if (permissions[i].name == 'scope_rate_configuration') {
                      self.cantAccessPage = true;

                  }
              }
          }

      }
  },
  mounted: function() {

        var self = this;
        self.getPermissions();
        var path = window.location.pathname;
        var segments = path.split("/");

        if (self.$route.query.from == 'status'){
            self.disCheck = true;
        }
        if (segments[3]) {
            self.loadScopeHeader();
            self.fetchRateConfig('','fixed');
        }
  },
  methods: {
    backHeaderList() {
      var self = this;
      self.$router.push("/scope-header/list");
    },

    fetchRateConfig:function(evt,flag){
        var self = this;
        self.fixed = '';
        self.dist = '';
        self.eltstb = '';
        self.enhour = '';
        self.reefer = '';

        self.activeFlag = flag;

        if (flag == 'fixed'){
            self.fixed = 'active';
            self.loadScopeRates('fixed');
        }else if(flag == 'dist'){
            self.dist = 'active';
            self.loadScopeRates('dist');
        }else if(flag == 'eltstb'){
            self.eltstb = 'active';
            self.loadScopeRates('eltstb');
        }else if(flag == 'enhour'){
            self.enhour = 'active';
            self.loadScopeRates('enhour');
        }else if(flag == 'rfhour'){
            self.reefer = 'active';
            self.loadScopeRates('rfhour');
        }
    },
    loadScopeHeader() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/card-rate-header/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {

                    self.contract_type = data.content.contract_type;
                    // self.customer_id = {value: data.content.customer_id, text: self.titleCase(data.content.customer)};
                    self.effective_date = data.content.effective_date;
                    self.expiry_date = data.content.expiry_date;
                    self.customer = self.titleCase(data.content.map_type);
                    self.scope = data.content.scope;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'load-contract-data')
            }
        });
    },


    loadScopeRates(flag) {

        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        var status = '';
        $.ajax({
            url: process.env.ROOT_API + "/card-rates-config/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            data:{
                flag:flag,
                status:status,
            },
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.rows = data.content.content;
                }

            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'card-rate-by-id')
            }
        });
    },
    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    activityLogs(){

      var self = this;
      var path = window.location.pathname;
      var segments = path.split("/");

      self.$root.$emit('activity_log_opted','scope rates',segments[3]);
      self.activityLogsTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
      self.activetab = 2;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CardRateConfigurationView.vue